
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Update, GetAllZones, GetById } from "adminApi/SlotApi/Slot.js";
import { validateForm } from "utils/validation";
import { SlotRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditSlotForm from "./components/EditSlotForm";
import fields from "../json/ZoneTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditSlot = () => {
    const { formdata } = fields;
    const { id } = useParams();
    const navigate = useNavigate();

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        SlotRules
    );

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    const { data: ZoneTypeOptions, loading } = useFetchAllData(GetAllZones);

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Update({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, SlotRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Slot updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loading || loadingFetch) && <Spinner isSpinner={true} />}
            <EditSlotForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Update Slot"
                ZoneTypeOptions={ZoneTypeOptions}
            />
        </>
    );
};

export default EditSlot;
